import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useHttpClient } from '@bonusly/http-client';

import { ApiResponse, RecognizeResponse } from '../types/api';
import { UserProfile } from '../types/user';

export const queryKey = 'navbar-profile';

/**
 * @deprecated Prefer `useCurrentUser` from `@bonusly/who-am-i` instead. More fields can be added to the response if needed.
 */
export const useUserProfile = (options: UseQueryOptions<ApiResponse<UserProfile>, unknown, UserProfile> = {}) => {
	const { i18n } = useTranslation('navigation');
	const http = useHttpClient();

	const query = useQuery<ApiResponse<UserProfile>, unknown, UserProfile>(
		[queryKey],
		() => {
			return http.get<RecognizeResponse<UserProfile>>('/profile/user', {
				params: { view: 'navigation' },
			});
		},
		{
			refetchInterval: Infinity,
			onSuccess: (user) => {
				const locale = user.locale;

				if (locale) {
					i18n.changeLanguage(locale);
				}
			},
			select: (data) => data.data.result,
			...options,
		}
	);

	return { ...query, user: query.data as UserProfile };
};
